var render = function render(){var _vm=this,_c=_vm._self._c;return _c('list-table',{attrs:{"url":_vm.url,"title":"لیست تسویه های شناسه دار","fields":_vm.fields,"params":_vm.params,"btns":_vm.btns,"excelroute":'excelroute'}})
}
var staticRenderFns = []

export { render, staticRenderFns }